/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auditor_Workflow_EditorInputs */

const en_auditor_workflow_editor = /** @type {(inputs: Auditor_Workflow_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow editor`)
};

const nl_auditor_workflow_editor = /** @type {(inputs: Auditor_Workflow_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow-editor`)
};

/**
* | output |
* | --- |
* | "Workflow editor" |
*
* @param {Auditor_Workflow_EditorInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const auditor_workflow_editor = /** @type {((inputs?: Auditor_Workflow_EditorInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auditor_Workflow_EditorInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_auditor_workflow_editor(inputs)
	return en_auditor_workflow_editor(inputs)
});